module.exports = __webpack_public_path__ + "img/loginheader.a64d58b3.png";